import { Component, HostListener, OnInit } from '@angular/core';
import { WebService } from '../shared/services/web.service';

import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import cloneDeep from 'lodash/cloneDeep';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableSortFn, NzTableSortOrder } from 'ng-zorro-antd/table';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import {fadeIn} from '../../app/shared/animation/animation.component';

interface DataItem {
  knowledge_base_id: number;
  question_text: string;
  checked: boolean;
  tag: any;
}

interface ColumnItem {
  name: string;
  sortOrder: NzTableSortOrder | null;
  sortFn: NzTableSortFn<DataItem> | null;
  sortDirections: NzTableSortOrder[];
}

@Component({
  selector: 'knowledge-base',
  templateUrl: './knowledge-base.component.html',
  styleUrls: ['./knowledge-base.component.css'],
  animations:[fadeIn]
})
export class KnowledgeBaseComponent implements OnInit {
  knowledgeBaseForm: FormGroup;
  metadata: any;
  knowledgeBaseData: any[];
  loadingFlag: boolean;
  updateMode: boolean;
  rawUpdateData: any;
  checkedData: any[];
  isIndeterminate: boolean;
  allChecked: boolean;
  anyChecked: boolean;
  resourceData: any[];
  iconVisible: boolean;
  knowledgeBaseFormVisible: boolean;
  knowledgeRadioVisible: boolean;
  radioValue = '2';
  resourceFilterList: any[];
  groupList: any;
  groupFilterList: any;
  knowledgeBaseDataRaw: any;
  tagMetaData: any;
  tagList: any[];
  tagFilterList: any[];
  updateKnowledgeBaseId: any;
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '130px',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText',
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    uploadUrl: 'v1/image',
    uploadWithCredentials: false,
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [['bold', 'italic'], ['fontSize']],
  };
  isLoading: boolean = false;
  isArchived: boolean = false;
  listOfColumns: ColumnItem[] = [
    {
      name: 'Knowledge Base',
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) =>
        a.question_text.localeCompare(b.question_text),
      sortDirections: ['ascend', 'descend', null],
    },
    {
      name: 'Tags',
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) => {
        const tagA = a.tag.map((tagObj) => tagObj.tag_name).join(', ');
        const tagB = b.tag.map((tagObj) => tagObj.tag_name).join(', ');
        return tagA.localeCompare(tagB);
      },
      sortDirections: ['ascend', 'descend', null],
    },
    {
      name: 'Actions',
      sortOrder: null,
      sortFn: null,
      sortDirections: [],
    },
  ];
  sortOrder: NzTableSortOrder | null;
  sortFn: NzTableSortFn<DataItem> | null;
  categoryFilterList: any[];
  submitFlag: boolean = true;
  showLoad: boolean;
  filterVisible: boolean;
  archived: any;
  appliedFilters: any[];
  isUsedInLast30Days: any;
  searchTerm:string;

  constructor(
    private webapi: WebService,
    private fb: FormBuilder,
    private notification: NzNotificationService,
    private modal: NzModalService
  ) {
    this.knowledgeBaseForm = this.fb.group({
      question_text: [null, [Validators.required]],
      answer_text: [null, [Validators.required]],
      resource_id: [null],
      tag: [null],
    });
    this.knowledgeBaseData = [];
    this.getKnowledgeBaseList({ filters: [] });
    this.getMetadata();
    this.categoryFilterList = [];
  }

  confirmModal?: NzModalRef; // For testing by now
  showConfirm(): void {
    this.confirmModal = this.modal.confirm({
      nzTitle:
        'All unsaved changes will be lost. Do you wish to proceed with closing the form?',
      nzContent: '',
      nzCentered: true,
      nzOnOk: () => {
        this.knowledgeBaseFormVisible = false;
      },
    });
  }



  //Code for unsaved changes starts.
  originalFormValue: any; // Store the original form value
  checkFormState() {
    if (this.isFormNotEmpty()) {
      this.showConfirm();
      return;
    }
    // Close the drawer if the form is empty
    this.knowledgeBaseFormVisible = false;
  }
  // Method to set the original form value before patchValue is called
  setOriginalFormValue(): void {
    this.originalFormValue = { ...this.knowledgeBaseForm.value };
  }

  // Updated hasFormChanged() method to check for value differences
  hasFormChanged(): boolean {
    if (!this.originalFormValue) {
      return false; // No original form value to compare (form not patched yet)
    }

    const formControls = this.knowledgeBaseForm.controls;
    for (const controlName in formControls) {
      if (formControls.hasOwnProperty(controlName)) {
        const originalValue = this.originalFormValue[controlName];
        const currentValue = formControls[controlName].value;
        if (originalValue != currentValue) {
          return true; // Found a difference in form values
        }
      }
    }

    return false; // No differences found in form values
  }

  isFormNotEmpty(): boolean {
    if (this.knowledgeBaseForm.controls) {
      if (this.hasFormChanged()) return true;
      else return false;
    } else {
      for (const controlName in this.knowledgeBaseForm.controls) {
        if (this.knowledgeBaseForm.controls.hasOwnProperty(controlName)) {
          const control = this.knowledgeBaseForm.get(controlName);
          if (control && control.value !== null && control.value !== '') {
            return true; // Form control has a non-empty value
          }
        }
      }
      return false; // No form control has a non-empty value
    }
    // Check if any form control has a non-empty value
  }

  ngOnInit() {}

  getMetadata(): void {
    this.webapi
      .requestJson('getMetaData', {
        metadata: ['resource', 'knowledge_base_tags'],
      })
      .subscribe(
        (data) => {
          let response = JSON.parse(data.body);
          this.metadata = cloneDeep(response.data);
          // this.knowledgeBaseData = [...this.metadata['knowledgeBaseData']];
          this.resourceData = [...this.metadata['resourceData']];
          this.resourceFilterList = [];
          this.resourceData.forEach((element) => {
            this.resourceFilterList.push({
              text: element.resource_name,
              value: element.resource_id,
              byDefault: false,
            });
          });

          this.tagMetaData = this.metadata.knowledgeBaseTagCategory;
          this.tagList = [...this.tagMetaData];
          this.tagFilterList = [];
          this.tagList.forEach((element) => {
            this.tagFilterList.push({
              text: element.name,
              value: element.tag_id,
              byDefault: false,
            });
          });

          // this.knowledgeBaseData.forEach((kb) => {
          //   kb.checked = false;
          // });

          // this.knowledgeBaseDataRaw = cloneDeep(this.knowledgeBaseData);
        },
        (error) => {
          var msg = error.headers.get('message');
          // this.showLoad = false;
          this.createNotification('error', '', 'An error occurred. Please try again later.');
        }
      );
  }

  getKnowledgeBaseList({ filters }): void {
    this.showLoad = true;
    this.webapi
      .requestJson('getKnowledgeBase', {
        Filters: filters.map((file) => {
          return {
            Key: file.key,
            Values: file.values,
          };
        }),
      })
      .subscribe(
        (data) => {
          let response = JSON.parse(data.body);
          this.knowledgeBaseData = [...response.data];
          this.knowledgeBaseData.forEach((kb) => {
            kb.checked = false;
          });

          this.knowledgeBaseDataRaw = cloneDeep(this.knowledgeBaseData);
          this.showLoad = false;
          // this.isLoading = false;
        },
        (error) => {
          console.log('ERROR', error);
          this.showLoad = false;
          this.createNotification('error', '', 'An error occurred. Please try again later.');
        }
      );
  }

  closeDetail() {
    this.iconVisible = false;
  }

  openKnowledgeBaseForm(): void {
    this.resetKnowledgeBaseForm();
    this.knowledgeBaseFormVisible = true;
    this.updateMode = false;
  }

  closeKnowledgeBaseForm(): void {
    this.resetKnowledgeBaseForm();
    this.knowledgeBaseData = cloneDeep(this.knowledgeBaseDataRaw);
    this.knowledgeBaseFormVisible = false;
  }
  openRadioValue() {
    this.knowledgeRadioVisible = true;
  }

  fillKnowledgeBaseForm(data) {
    this.openKnowledgeBaseForm();

    this.knowledgeBaseForm.patchValue({
      question_text: data.question_text,
      answer_text: data.answer_text,
      resource_id: data.resource_id,
    });
    const tagIds = data.tag.map((tag) => tag.tag_id);
    this.knowledgeBaseForm.controls.tag.setValue(tagIds);
    this.updateMode = true;
    this.updateKnowledgeBaseId = data.knowledge_base_id;
    this.rawUpdateData = { ...data };
    this.originalFormValue = this.knowledgeBaseForm.value; //latest
  }

  resetKnowledgeBaseForm(): void {
    this.knowledgeBaseForm.reset();
    this.updateMode = false;
    this.updateKnowledgeBaseId = undefined;
    this.rawUpdateData = {};
    this.originalFormValue = this.knowledgeBaseForm.value; //latest
  }

  resetUpdateForm(): void {
    this.knowledgeBaseForm.patchValue(this.rawUpdateData);
    const tagIds = this.rawUpdateData.tag.map((tag) => tag.tag_id);

    this.knowledgeBaseForm.patchValue({
      question_text: this.rawUpdateData.question_text,
    });

    this.knowledgeBaseForm.controls.tag.setValue(tagIds);
  }

  onType(){
    console.log(this.knowledgeBaseForm.value);
  }
  submitKnowledgeBase() {
    this.isArchived = false;
    this.archived = false;
    this.isLoading = true;
    let obj = {
      ...this.knowledgeBaseForm.value,
    };
    this.webapi.requestJson('addKnowledgeBase', obj).subscribe(
      (data) => {
        var response = JSON.parse(data.body);
        this.isLoading = false;
        this.createNotification('success', '', response['message']);
        // this.getKnowledgeBaseList({ filters: [] });
        this.applyFilters()
        this.closeKnowledgeBaseForm();
        // this.knowledgeBaseData = [...response.data];
        // this.knowledgeBaseData.forEach((kb) => {
        //   kb.checked = false;
        // });
        // this.knowledgeBaseDataRaw = cloneDeep(this.knowledgeBaseData);
      },
      (error) => {
        this.isLoading = false;
        this.createNotification('error', '', 'An error occurred. Please try again later.');
      }
    );
  }

  updateKnowledgeBase(): void {
    
    this.isLoading = true;
    let updateObj = {
      knowledge_base_id: this.updateKnowledgeBaseId,
      ...this.knowledgeBaseForm.value,
    };

    this.webapi.requestJson('updateKnowledgeBase', updateObj).subscribe(
      (data) => {
        var response = JSON.parse(data.body);
        this.isLoading = false;
        this.createNotification('success', '', response['message']);
        this.getKnowledgeBaseList({ filters: [] });
        this.closeKnowledgeBaseForm();
        // this.knowledgeBaseData = [...response.data];

        // this.knowledgeBaseDataRaw = cloneDeep(this.knowledgeBaseData);
      },
      (error) => {
        this.isLoading = false;
        this.createNotification('error', '', 'An error occurred. Please try again later.');
      }
    );
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) {
  if (this.hasFormChanged()) {
    $event.preventDefault();
    $event.returnValue = 'You have unsaved changes. Are you sure you want to leave?'; // For some browsers
  }
}
  createNotification(type, title, msg): void {
    this.notification.create(type, title, msg);
  }

  checkAll(value: boolean): void {
    this.knowledgeBaseData.forEach((data) => {
      data.checked = value;
    });
    this.refreshStatus();
  }

  refreshStatus(): void {
    this.checkedData = [];
    this.knowledgeBaseData.forEach((element) => {
      if (element.checked) {
        this.checkedData.push(element.knowledge_base_id);
      }
    });
    this.anyChecked = this.knowledgeBaseData.some((e) => e.checked);
    this.allChecked = this.knowledgeBaseData.every((e) => e.checked);
  }

  deleteKnowledgeBase(knowledgeBaseId: any = null, multi = false): void {
    this.showLoad = true;
    let obj = {
      knowledge_base_id: [knowledgeBaseId],
    };
    if (multi) {
      obj.knowledge_base_id = [];
      obj.knowledge_base_id = this.checkedData;
    }
    this.webapi.requestJson('deleteKnowledgeBase', obj).subscribe(
      (data) => {
        var response = JSON.parse(data.body);
        this.isLoading = false;
        // this.knowledgeBaseData = [...response.data];
        this.createNotification('success', '', 'Deletion successful.');
        this.getKnowledgeBaseList({ filters: [] });
        this.anyChecked = false;
      },
      (error) => {
        this.isLoading = false;
        this.createNotification('error', '', 'An error occurred. Please try again later.');
      }
    );
  }

  onKeyUp(query: string): void {
    if (query) {
      let q: string;
      q = query.toLowerCase();
      const searchData = this.knowledgeBaseDataRaw.filter((d) => {
        var found = false;
        d.tag.forEach((tag) => {
          if (tag.tag_name.toLowerCase().includes(q)) {
            found = true;
          }
        });
        if (
          (d.question_text && d.question_text.toLowerCase().includes(q)) ||
          found
        ) {
          return d;
        }
      });
      this.knowledgeBaseData = searchData;
      this.knowledgeBaseData = [...this.knowledgeBaseData];
    } else {
      this.knowledgeBaseData = [...this.knowledgeBaseDataRaw];
    }
  }
  resetSearch(){
    if(this.searchTerm){
      this.searchTerm=''
      this.knowledgeBaseData = [...this.knowledgeBaseDataRaw];

    }
  }

  getMoreTagsContent(tags): string[] {
    return tags.slice(2).map((tag) => tag.tag_name);
  }

  moreTagsContent: string[];

  updateMoreTagsContent(tags): void {
    this.moreTagsContent = this.getMoreTagsContent(tags);
  }

  resetMoreTagsContent(): void {
    this.moreTagsContent = [];
  }

  
  
  // clickFilter() {
  //   this.getKnowledgeBaseList({ filters: [] });
  //   this.filterVisible = false;
  // }

  onPopoverVisibleChange(visible: boolean) {
    if (!visible) {
      this.clickFilter()
    } else {
      console.log('Popover is now visible');
    }
  }

  applyFilters() {
    this.appliedFilters = [];

    // if (this.isUsedInLast30Days) {
    //   this.appliedFilters.push({ key: 'status', values: ['0'] });
    //   this.filterVisible = false;
    // }

    if (this.archived) {
      this.appliedFilters.push({ key: 'status', values: ['2'] });
      this.filterVisible = false;
      this.isArchived = true;
      
    }

    this.getKnowledgeBaseList({ filters: this.appliedFilters });
    this.filterVisible = false;
 
  }

  clickFilter() {
    this.filterVisible = false;
    if (this.appliedFilters && this.appliedFilters.length > 0) {
        // this.isUsedInLast30Days = this.appliedFilters.some(filter => filter.values.includes('0'));
        this.archived = this.appliedFilters.some(filter => filter.values.includes('2'));
    } else {
        // this.isUsedInLast30Days = false;
        this.archived = false;
        this.isArchived = false;
        
    }
}
}
